import Icon from '../components/Icon.vue'

Icon.register({
  'sad-cry': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8C111 8 0 119 0 256 0 346.1 48.2 424.7 120 468.1V288C120 279.2 127.2 272 136 272S152 279.2 152 288V484.7C181.5 497.1 214 504 248 504S314.5 497.1 344 484.7V288C344 279.2 351.2 272 360 272S376 279.2 376 288V468.1C447.8 424.7 496 346 496 256 496 119 385 8 248 8zM182.5 224.5C167.7 211.3 136.3 211.3 121.5 224.5L112 233C108.2 236.3 102.7 237 98.3 234.6 93.9 232.2 91.4 227.2 92.2 222.2 96.2 197 126.4 180.1 152.1 180.1S208 197 212 222.2C212.8 227.2 210.3 232.2 205.9 234.6 200.1 237.7 194.7 235.3 192.2 233L182.5 224.5zM248 416C221.5 416 200 387.3 200 352S221.5 288 248 288 296 316.7 296 352 274.5 416 248 416zM397.8 234.5C392 237.6 386.6 235.2 384.1 232.9L374.6 224.4C359.8 211.2 328.4 211.2 313.6 224.4L304 233C300.2 236.3 294.7 237 290.3 234.6 285.9 232.2 283.4 227.2 284.2 222.2 288.2 197 318.4 180.1 344.1 180.1S400 197 404 222.2C404.6 227.1 402.2 232.1 397.8 234.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/sad-cry.js
// module id = I+r6
// module chunks = 144